import { observer } from "mobx-react-lite";
import { useMemo } from "react";

import { useAssignSetAssignedValues } from "src/workouts/useAssignSetAssignedValues";
import {
  type WorkoutItemSetProviderProps,
  useWorkoutItemSave,
  workoutItemSetContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export const EditWorkoutItemWorkoutSetProvider = observer(
  function EditWorkoutItemWorkoutSetProvider(
    props: WorkoutItemSetProviderProps,
  ) {
    const workoutItemsPermissions = useWorkoutPermissions();
    const assignSetAssignedValues = useAssignSetAssignedValues();
    const requestSave = useWorkoutItemSave();

    const value = useMemo(() => {
      return {
        getType: () => {
          return props.attribute.exerciseAttribute.type;
        },
        updateEditableValue: (value: string) => {
          assignSetAssignedValues({
            workoutSetId: props.workoutSet.id,
            exerciseAttributeId: props.attribute.exerciseAttributeId,
            assignedValue: value,
          });
          requestSave();
        },
        getEditableValue: () => {
          if (!props.attributeValue) {
            return "";
          }

          return props.attributeValue.assignedValue;
        },
        getEditableInputId: () => {
          return `${props.workoutSet.id}:${props.attribute.exerciseAttributeId}:${props.attribute.exerciseAttribute.type}`;
        },
        isEditableInputDisabled: () => {
          return !workoutItemsPermissions.canEditSets;
        },
        renderAssignedValue: () => {
          return null;
        },
      };
    }, [
      props.attributeValue?.assignedValue,
      props.attribute.exerciseAttribute.type,
      props.attribute.exerciseAttributeId,
      props.workoutSet.id,
      workoutItemsPermissions.canEditSets,
      requestSave,
    ]);

    return (
      <workoutItemSetContext.Provider value={value}>
        {props.children}
      </workoutItemSetContext.Provider>
    );
  },
);
